export default function initM3() {
    jQuery(".brandSLider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.brandSliderSingle',
        focusOnSelect: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '100px',
                }
            }
        ]
    })
    
    jQuery(".brandSliderSingle").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow:'<svg class="prevArrow" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none"><rect width="49" height="49" rx="24.5" transform="matrix(-1 0 0 1 49 0)" fill="#0FF"/><path d="M35.025 24.462H14.118" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="round"/><path d="m22.55 32.965-8.432-8.433M22.55 15.894l-8.433 8.433" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="square"/></svg>',
        nextArrow:'<svg class="nextArrow" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none"><rect width="49" height="49" rx="24.5" fill="#0FF"/><path d="M13.975 24.462h20.907" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="round"/><path d="m26.45 32.965 8.433-8.433M26.45 15.894l8.433 8.433" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="square"/></svg>',
        asNavFor: '.brandSLider',
        centerMode: true,
        centerPadding: '100px',
        draggable: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '0px',
                },
                breakpoint: 991,
                settings: {
                    dots: true, centerPadding: '0px',
                }
            }
        ]
    })
}